import type { ExternalUser } from "@/types/externalUser";

/**
 * Narrows the loaded rows by search term.
 *
 * This runs here rather than upstream because the screen already holds every
 * user: the list is fetched in one call and the profile fields come with it.
 * Filtering locally is therefore instant, and — unlike an upstream search — it
 * cannot disagree with what is on screen.
 *
 * Matches a first name, a last name, an email address or a T1 user id,
 * case-insensitively and on any part of the value. The id is matched as text
 * on purpose: somebody squinting at a long number wants the digits they can
 * remember to narrow the list, not an exact-match lookup.
 */
export const filterUsers = (
  users: ExternalUser[],
  search: string
): ExternalUser[] => {
  const query = search.trim().toLowerCase();
  if (query === "") return users;

  return users.filter((user) =>
    [
      user.firstName,
      user.lastName,
      `${user.firstName} ${user.lastName}`.trim(),
      user.email,
      user.t1UserId === null ? "" : String(user.t1UserId),
    ].some((field) => field.toLowerCase().includes(query))
  );
};
